// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"50":"f7d1d366","145":"a2c4a9e6","375":"22ec113d","485":"cb2b669d","883":"b8c1f573","977":"9e7515d7"}[chunkId] + ".css";
};